import { Agreement } from "./agreement";
// import { User } from "./user";

class Store {
  #entities: { agreement: Agreement };

  constructor() {
    this.#entities = {
      // user: new User(),
      agreement: new Agreement(),
    };

    this.init = this.init.bind(this);
  }

  get entities() {
    return this.#entities;
  }

  async init() {
    await Promise.all(
      Object.values(this.#entities).map((entity) => entity.init()),
    );
  }
}

export { Store };
